import React, { Component } from "react";
import { Grid, Card, Table, Badge, Form, Button, Icon, Dimmer } from "tabler-react";
import Modal from "react-modal";
import SiteWrapper from "../../SiteWrapper.react";
import { api_raiz } from "../../config/config";
import "./CelloIntegrationPage.css";

const EVENT_CODE_MAP = {
  "1": "In Transit",
  "2": "Cita en centro de carga",
  "3": "Hora de salida máxima",
  "4": "Cita en cliente",
  "5": "Llegada de unidad a centro de carga",
  "6": "Reporte en centro de carga",
  "7": "Asignación de cortina en centro de carga",
  "8": "Inicio de carga",
  "9": "Fin de carga",
  "10": "Entrega de documentos a control tower",
  "11": "Inicio de ruta",
  "12": "La unidad no reinicia en tiempo",
  "13": "Llegada tardía a cliente",
  "14": "Llegada tardía por carretera cerrada",
  "15": "Tráfico por accidente de terceros",
  "16": "Tráfico por cierre carretero",
  "17": "Detención por autoridades",
  "18": "Fenómenos Naturales",
  "19": "Contingencia Ambiental",
  "20": "Las facturas no se visualizan en el portal del cliente",
  "21": "Llegada a cliente",
  "22": "Entrega de documentos en cliente",
  "23": "Asignación de rampa en cliente",
  "24": "Inicio de descarga",
  "25": "Fin de descarga",
  "26": "Entrega de PODs",
  "27": "Rechazo total por plaga",
  "28": "Rechazo total por empaque dañado",
  "29": "Finalizado Rechazo Parcial",
  "30": "Operador dormido",
  "31": "Operador se reporta tarde con cliente",
  "32": "Operador no se reporta ha llamado de descarga",
  "33": "Parada no autorizada",
  "34": "Operador inicia tarde en pensión",
  "35": "Operador inicia tarde la ruta",
  "36": "Falla mecánica",
  "37": "Error de Genpact o Boc",
  "38": "Robo",
  "39": "Custodia",
  "40": "Cambios de domicilio",
  "41": "Códigos QR",
  "42": "Tipo de unidad",
  "43": "Cambio de cita",
};

function extractFromRequest(requestJson) {
  try {
    const data = JSON.parse(requestJson);
    // Buscar en trackingInfo o truckInfo (puede ser objeto o array)
    let source = data.trackingInfo || data.truckInfo;
    if (!source) return { mnfNo: "", doNo: "", carrierName: "" };
    if (!Array.isArray(source)) source = [source];
    if (source.length === 0) return { mnfNo: "", doNo: "", carrierName: "" };

    const manifests = source[0].manifests || [];
    if (manifests.length === 0) return { mnfNo: "", doNo: "", carrierName: "" };

    const m = manifests[0];
    const mnfNo = m.mnfNo || data.documentnumber || "";
    const carrierName = m.carrierName || m.carrierNm || "";
    const shipments = m.shipments || [];
    const doNo = shipments[0]?.deliveryOrders?.[0]?.doNo || "";

    return { mnfNo, doNo, carrierName };
  } catch (e) {
    return { mnfNo: "—", doNo: "—", carrierName: "—" };
  }
}

class CelloIntegrationPage extends Component {
  constructor(props) {
    super(props);
    const today = new Date();
    const todayStr = today.toISOString().slice(0, 10);
    this.state = {
      fecha1: todayStr + " 00:00:00",
      fecha2: todayStr + " 23:59:59",
      search: "",
      // Webhooks recibidos
      webhooks: [],
      webhooksTotal: 0,
      webhooksPage: 1,
      webhooksTotalPages: 1,
      webhooksLoading: false,
      // Eventos enviados (detalle)
      selectedWebhook: null,
      eventos: [],
      eventosTotal: 0,
      eventosPage: 1,
      eventosTotalPages: 1,
      eventosLoading: false,
      // General
      pageSize: 7,
      error: null,
      // Modal
      showModal: false,
      selectedEvento: null,
      showRequest: true,
    };
  }

  componentDidMount() {
    this.fetchWebhooks(1);
  }

  fetchWebhooks = (page) => {
    const { fecha1, fecha2, search, pageSize } = this.state;
    if (!fecha1 || !fecha2) return;

    this.setState({ webhooksLoading: true, error: null });

    let url = `${api_raiz}samsung/webhooks-recibidos?fecha1=${encodeURIComponent(fecha1)}&fecha2=${encodeURIComponent(fecha2)}&page=${page}&size=${pageSize}`;
    if (search && search.trim()) {
      url += `&search=${encodeURIComponent(search.trim())}`;
    }

    fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("tok"),
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((response) => {
        this.setState({
          webhooks: response.content || [],
          webhooksTotal: response.totalElements || 0,
          webhooksPage: response.page || 1,
          webhooksTotalPages: response.totalPages || 1,
          webhooksLoading: false,
        });
      })
      .catch((error) => {
        this.setState({ error: error.message, webhooksLoading: false });
      });
  };

  fetchEventos = (idMovimiento, page) => {
    const { fecha1, fecha2, pageSize } = this.state;
    this.setState({ eventosLoading: true });

    let url = `${api_raiz}samsung/delivery-events?fecha1=${encodeURIComponent(fecha1)}&fecha2=${encodeURIComponent(fecha2)}&idMovimiento=${idMovimiento}&page=${page || 1}&size=${pageSize}`;

    fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("tok"),
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((response) => {
        this.setState({
          eventos: response.content || [],
          eventosTotal: response.totalElements || 0,
          eventosPage: response.page || 1,
          eventosTotalPages: response.totalPages || 1,
          eventosLoading: false,
        });
      })
      .catch(() => {
        this.setState({ eventos: [], eventosLoading: false });
      });
  };

  selectWebhook = (webhook) => {
    // Si se pulsa el mismo, deseleccionar
    if (this.state.selectedWebhook && this.state.selectedWebhook.id === webhook.id) {
      this.setState({ selectedWebhook: null, eventos: [], eventosPage: 1 });
      return;
    }
    this.setState({ selectedWebhook: webhook, eventos: [], eventosPage: 1 }, () => {
      if (webhook.movimiento) {
        this.fetchEventos(webhook.movimiento, 1);
      }
    });
  };

  handleKeyDown = (e) => {
    if (e.key === "Enter") this.fetchWebhooks(1);
  };

  isSuccess = (response) => {
    if (!response) return false;
    return response.startsWith("200") || response.includes("200 -");
  };

  openModal = (ev) => {
    this.setState({ showModal: true, selectedEvento: ev, showRequest: true });
  };

  closeModal = () => {
    this.setState({ showModal: false, selectedEvento: null });
  };

  formatJson = (str) => {
    if (!str) return "—";
    try {
      return JSON.stringify(JSON.parse(str), null, 2);
    } catch (e) {
      return str;
    }
  };

  render() {
    const {
      fecha1, fecha2, search,
      webhooks, webhooksTotal, webhooksPage, webhooksTotalPages, webhooksLoading,
      selectedWebhook, eventos, eventosTotal, eventosPage, eventosTotalPages, eventosLoading,
      pageSize, error,
    } = this.state;

    // Máximo permitido en los pickers = ahora (no se permiten fechas futuras)
    const nowLocal = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 16);

    return (
      <SiteWrapper>
        <div className="my-3 my-md-5" style={{ padding: "20px", background: "#ffffff", borderRadius: 8, boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>
          <div className="page-header">
            <h1 className="page-title">Samsung SEM — Integración Cello (Webhooks Recibidos → Eventos Enviados)</h1>
          </div>

          {/* Filtros */}
          <Card style={{ borderLeft: "4px solid #467fcf", marginBottom: 16 }}>
            <Card.Body style={{ padding: "12px 20px" }}>
              <Grid.Row alignItems="flex-end">
                <Grid.Col md={3}>
                  <Form.Group label="Fecha Inicio">
                    <Form.Input
                      type="datetime-local"
                      max={nowLocal}
                      value={fecha1.replace(" ", "T").slice(0, 16)}
                      onChange={(e) => this.setState({ fecha1: e.target.value.replace("T", " ") + ":00" })}
                      onKeyDown={this.handleKeyDown}
                    />
                  </Form.Group>
                </Grid.Col>
                <Grid.Col md={3}>
                  <Form.Group label="Fecha Fin">
                    <Form.Input
                      type="datetime-local"
                      max={nowLocal}
                      value={fecha2.replace(" ", "T").slice(0, 16)}
                      onChange={(e) => this.setState({ fecha2: e.target.value.replace("T", " ") + ":00" })}
                      onKeyDown={this.handleKeyDown}
                    />
                  </Form.Group>
                </Grid.Col>
                <Grid.Col md={4}>
                  <Form.Group label="Buscar (DO, Manifiesto, Movimiento, Método)">
                    <Form.Input
                      placeholder="Ej: 7317993826910, M550000006, create..."
                      value={search}
                      onChange={(e) => this.setState({ search: e.target.value })}
                      onKeyDown={this.handleKeyDown}
                    />
                  </Form.Group>
                </Grid.Col>
                <Grid.Col md={2}>
                  <Form.Group label="&nbsp;">
                    <Button color="primary" onClick={() => this.fetchWebhooks(1)} loading={webhooksLoading} block>
                      <Icon name="search" /> Buscar
                    </Button>
                  </Form.Group>
                </Grid.Col>
              </Grid.Row>
            </Card.Body>
          </Card>

          {error && (
            <div className="alert alert-danger" style={{ borderRadius: 8 }}>
              <Icon name="alert-circle" /> {error}
            </div>
          )}

          {/* Tabla de Webhooks Recibidos */}
          <Card>
            <Card.Header style={{ background: "#f8f9fa" }}>
              <Card.Title className="cello-title" style={{ color: "#495057" }}>
                <Icon name="download" /> Webhooks Recibidos de Samsung — {webhooksTotal} registros
              </Card.Title>
            </Card.Header>
            <Dimmer active={webhooksLoading} loader>
              <Card.Body style={{ padding: 0, overflowX: "auto", overflowY: "auto", maxHeight: selectedWebhook ? "none" : 350 }}>
                {webhooks.length === 0 && !webhooksLoading ? (
                  <div style={{ textAlign: "center", padding: 40, color: "#9aa0ac" }}>
                    <div style={{ fontSize: "2rem", marginBottom: 8 }}>📭</div>
                    <p>No se encontraron webhooks para el rango seleccionado.</p>
                  </div>
                ) : (
                  <Table striped responsive className="table-vcenter">
                    <Table.Header>
                      <Table.Row>
                        <Table.ColHeader style={{ width: 50 }}>ID</Table.ColHeader>
                        <Table.ColHeader>Mov.</Table.ColHeader>
                        <Table.ColHeader>DO (unique_identifier)</Table.ColHeader>
                        <Table.ColHeader>Manifiesto</Table.ColHeader>
                        <Table.ColHeader>Transportista</Table.ColHeader>
                        <Table.ColHeader>Fecha Recepción</Table.ColHeader>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {(selectedWebhook ? webhooks.filter(wh => wh.id === selectedWebhook.id) : webhooks).map((wh) => {
                        const info = extractFromRequest(wh.request);
                        const isSelected = selectedWebhook && selectedWebhook.id === wh.id;
                        return (
                          <Table.Row
                            key={wh.id}
                            style={{
                              cursor: "pointer",
                              background: isSelected ? "#e8f4fd" : undefined,
                              borderLeft: isSelected ? "3px solid #467fcf" : "3px solid transparent",
                            }}
                            onClick={() => this.selectWebhook(wh)}
                          >
                            <Table.Col className="text-muted" style={{ fontSize: "0.8rem" }}>
                              {wh.id}
                            </Table.Col>
                            <Table.Col>
                              <strong>{wh.movimiento || "—"}</strong>
                            </Table.Col>
                            <Table.Col style={{ fontSize: "0.82rem" }}>
                              <code style={{ background: "#f1f3f5", padding: "2px 6px", borderRadius: 4 }}>
                                {wh.uniqueIdentifier || info.doNo || "—"}
                              </code>
                            </Table.Col>
                            <Table.Col style={{ fontSize: "0.82rem" }}>
                              {info.mnfNo || "—"}
                            </Table.Col>
                            <Table.Col style={{ fontSize: "0.8rem", maxWidth: 150, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                              {info.carrierName || "—"}
                            </Table.Col>
                            <Table.Col style={{ whiteSpace: "nowrap", fontSize: "0.8rem" }}>
                              {wh.accionFecha || "—"}
                            </Table.Col>
                          </Table.Row>
                        );
                      })}
                    </Table.Body>
                  </Table>
                )}
              </Card.Body>
            </Dimmer>
            {webhooksTotalPages > 1 && !selectedWebhook && (
              <Card.Footer style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 20px" }}>
                <div style={{ fontSize: "0.85rem", color: "#6e7687" }}>
                  {((webhooksPage - 1) * pageSize) + 1} - {Math.min(webhooksPage * pageSize, webhooksTotal)} de {webhooksTotal}
                </div>
                <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                  <Button size="sm" color="secondary" outline disabled={webhooksPage === 1} onClick={() => this.fetchWebhooks(1)}>«</Button>
                  <Button size="sm" color="secondary" outline disabled={webhooksPage === 1} onClick={() => this.fetchWebhooks(webhooksPage - 1)}>‹</Button>
                  <span style={{ padding: "0 10px", fontSize: "0.85rem" }}>Pág. {webhooksPage}/{webhooksTotalPages}</span>
                  <Button size="sm" color="secondary" outline disabled={webhooksPage === webhooksTotalPages} onClick={() => this.fetchWebhooks(webhooksPage + 1)}>›</Button>
                  <Button size="sm" color="secondary" outline disabled={webhooksPage === webhooksTotalPages} onClick={() => this.fetchWebhooks(webhooksTotalPages)}>»</Button>
                </div>
              </Card.Footer>
            )}
          </Card>

          {/* Panel de detalle: Eventos enviados a Cello para el movimiento seleccionado */}
          {selectedWebhook && (
            <Card style={{ marginTop: 16, borderLeft: "4px solid #2fb344" }}>
              <Card.Header style={{ background: "#f8f9fa" }}>
                <Card.Title className="cello-title" style={{ color: "#495057" }}>
                  <Icon name="send" /> Eventos enviados a Cello para Movimiento <strong>{selectedWebhook.movimiento}</strong>
                  {" "}— DO: <code>{selectedWebhook.uniqueIdentifier || "—"}</code>
                  {" "}— Manifiesto: <code>{extractFromRequest(selectedWebhook.request).mnfNo || "—"}</code>
                </Card.Title>
              </Card.Header>
              <Dimmer active={eventosLoading} loader>
                <Card.Body style={{ padding: 0, overflowX: "auto", overflowY: "auto", maxHeight: 300 }}>
                  {eventos.length === 0 && !eventosLoading ? (
                    <div style={{ textAlign: "center", padding: 30, color: "#9aa0ac" }}>
                      <p>No se encontraron eventos enviados a Cello para este movimiento en el rango de fechas.</p>
                    </div>
                  ) : (
                    <Table striped responsive className="table-vcenter">
                      <Table.Header>
                        <Table.Row>
                          <Table.ColHeader style={{ width: 50 }}>ID</Table.ColHeader>
                          <Table.ColHeader>Event Code</Table.ColHeader>
                          <Table.ColHeader>Descripción</Table.ColHeader>
                          <Table.ColHeader>Método</Table.ColHeader>
                          <Table.ColHeader>Fecha Envío</Table.ColHeader>
                          <Table.ColHeader>Status</Table.ColHeader>
                          <Table.ColHeader style={{ width: 60 }}></Table.ColHeader>
                        </Table.Row>
                      </Table.Header>
                      <Table.Body>
                        {eventos.map((ev) => (
                          <Table.Row key={ev.id}>
                            <Table.Col className="text-muted" style={{ fontSize: "0.8rem" }}>{ev.id}</Table.Col>
                            <Table.Col><Badge color="primary">{ev.eventCode || "—"}</Badge></Table.Col>
                            <Table.Col style={{ fontSize: "0.82rem" }}>{EVENT_CODE_MAP[ev.eventCode] || ev.metodo || "—"}</Table.Col>
                            <Table.Col style={{ fontSize: "0.82rem" }}>{ev.metodo || "—"}</Table.Col>
                            <Table.Col style={{ whiteSpace: "nowrap", fontSize: "0.8rem" }}>{ev.accionFecha || "—"}</Table.Col>
                            <Table.Col>
                              {this.isSuccess(ev.response) ? (
                                <Badge color="success">✓ 200</Badge>
                              ) : (
                                <Badge color="danger">✗ Error</Badge>
                              )}
                            </Table.Col>
                            <Table.Col>
                              <Button size="sm" color="secondary" outline onClick={() => this.openModal(ev)} title="Ver request/response">
                                <Icon name="eye" />
                              </Button>
                            </Table.Col>
                          </Table.Row>
                        ))}
                      </Table.Body>
                    </Table>
                  )}
                </Card.Body>
              </Dimmer>
              {eventosTotalPages > 1 && (
                <Card.Footer style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 20px" }}>
                  <div style={{ fontSize: "0.85rem", color: "#6e7687" }}>
                    {((eventosPage - 1) * pageSize) + 1} - {Math.min(eventosPage * pageSize, eventosTotal)} de {eventosTotal}
                  </div>
                  <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                    <Button size="sm" color="secondary" outline disabled={eventosPage === 1} onClick={() => this.fetchEventos(selectedWebhook.movimiento, 1)}>«</Button>
                    <Button size="sm" color="secondary" outline disabled={eventosPage === 1} onClick={() => this.fetchEventos(selectedWebhook.movimiento, eventosPage - 1)}>‹</Button>
                    <span style={{ padding: "0 10px", fontSize: "0.85rem" }}>Pág. {eventosPage}/{eventosTotalPages}</span>
                    <Button size="sm" color="secondary" outline disabled={eventosPage === eventosTotalPages} onClick={() => this.fetchEventos(selectedWebhook.movimiento, eventosPage + 1)}>›</Button>
                    <Button size="sm" color="secondary" outline disabled={eventosPage === eventosTotalPages} onClick={() => this.fetchEventos(selectedWebhook.movimiento, eventosTotalPages)}>»</Button>
                  </div>
                </Card.Footer>
              )}
            </Card>
          )}

          {/* Modal Request/Response */}
          <Modal
            isOpen={this.state.showModal}
            onRequestClose={this.closeModal}
            style={{
              content: {
                top: "5%",
                left: "8%",
                right: "8%",
                bottom: "5%",
                borderRadius: 12,
                padding: 0,
                border: "none",
                boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
                display: "flex",
                flexDirection: "column",
              },
              overlay: { backgroundColor: "rgba(0,0,0,0.6)", zIndex: 9999 },
            }}
          >
            {this.state.selectedEvento && (() => {
              const ev = this.state.selectedEvento;
              return (
                <div>
                  <div style={{ padding: "16px 24px", borderBottom: "1px solid #e9ecef", display: "flex", justifyContent: "space-between", alignItems: "center", background: "#f8f9fa" }}>
                    <h5 className="cello-title" style={{ margin: 0, color: "#495057" }}>
                      Evento #{ev.id} — <Badge color="primary">{ev.eventCode}</Badge> {EVENT_CODE_MAP[ev.eventCode] || ev.metodo} — Mov. <strong>{ev.movimiento}</strong>
                    </h5>
                    <Button color="secondary" size="sm" onClick={this.closeModal}>
                      <Icon name="x" />
                    </Button>
                  </div>
                  <div style={{ padding: 24, display: "flex", flexDirection: "column", height: "calc(100% - 60px)" }}>
                    <Grid.Row style={{ marginBottom: 16 }}>
                      <Grid.Col md={3}>
                        <small style={{ color: "#9aa0ac", textTransform: "uppercase", fontSize: "0.7rem" }}>Fecha Envío</small>
                        <div>{ev.accionFecha || "—"}</div>
                      </Grid.Col>
                      <Grid.Col md={3}>
                        <small style={{ color: "#9aa0ac", textTransform: "uppercase", fontSize: "0.7rem" }}>Status</small>
                        <div>
                          {this.isSuccess(ev.response) ? (
                            <Badge color="success">✓ Exitoso (200)</Badge>
                          ) : (
                            <Badge color="danger">✗ Error</Badge>
                          )}
                        </div>
                      </Grid.Col>
                      <Grid.Col md={6}>
                        <small style={{ color: "#9aa0ac", textTransform: "uppercase", fontSize: "0.7rem" }}>Respuesta Cello</small>
                        <div style={{ fontSize: "0.85rem", color: this.isSuccess(ev.response) ? "#2fb344" : "#d63939" }}>
                          {ev.response || "Sin respuesta"}
                        </div>
                      </Grid.Col>
                    </Grid.Row>

                    <div style={{ marginBottom: 12 }}>
                      <Button
                        size="sm"
                        color={this.state.showRequest ? "primary" : "secondary"}
                        onClick={() => this.setState({ showRequest: true })}
                        style={{ marginRight: 8 }}
                      >
                        <Icon name="upload" /> Request (JSON enviado a Cello)
                      </Button>
                      <Button
                        size="sm"
                        color={!this.state.showRequest ? "primary" : "secondary"}
                        onClick={() => this.setState({ showRequest: false })}
                      >
                        <Icon name="download" /> Response (Respuesta de Cello)
                      </Button>
                    </div>

                    <pre style={{
                      background: "#1e1e2e",
                      color: "#a6e3a1",
                      padding: 20,
                      borderRadius: 8,
                      overflowX: "auto",
                      overflowY: "auto",
                      fontSize: "0.78rem",
                      lineHeight: 1.6,
                      margin: 0,
                      flex: 1,
                      border: "1px solid #313244",
                    }}>
                      {this.state.showRequest
                        ? this.formatJson(ev.request)
                        : ev.response || "Sin respuesta"}
                    </pre>
                  </div>
                </div>
              );
            })()}
          </Modal>
        </div>
      </SiteWrapper>
    );
  }
}

export default CelloIntegrationPage;
